import React from 'react'

export default function({ item }) {
  return <div style={{color: item.grade_color, display: 'flex', justifyContent: 'space-between'}}>
    <span>Grade: {item.grade}</span>
    <span>Rating: {item.rating}</span>
    <span>Percentile: {item.percentile}</span>
  </div>
}